import { render, staticRenderFns } from "./InformeDetalleViaje.vue?vue&type=template&id=472868c8&scoped=true&"
import script from "./InformeDetalleViaje.vue?vue&type=script&lang=ts&"
export * from "./InformeDetalleViaje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472868c8",
  null
  
)

export default component.exports